import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const StatusHistoryPage = withSuspense(
	lazy(async () => await import('./status-history-page.component')),
	PageLoader,
);
